import { FormikProps } from "formik"
import { HourReportFormState } from "../../schemas"
import ManualEntryFields from "../ManualEntryFields"
import { Box, Typography } from "@material-ui/core"
import { useTranslation } from "react-i18next"

export const ManualEntry = ({ formik }: Props) => {
  const { t } = useTranslation("hour-report")
  const { values, errors, touched } = formik

  const hours = "hours" in values ? values.hours : 0
  const hoursTouched = "hours" in touched ? touched.hours : false
  const hoursError = "hours" in errors ? errors.hours : undefined
  const isHoursError = hoursTouched && Boolean(hoursError)
  const hoursErrorText = isHoursError ? hoursError : undefined
  const minutes = "minutes" in values ? values.minutes || 0 : 0
  const minutesTouched = "minutes" in touched ? touched.minutes : false
  const minutesError = "minutes" in errors ? errors.minutes : undefined
  const isMinutesError = minutesTouched && Boolean(minutesError)
  const minutesErrorText = isMinutesError ? minutesError : undefined

  return (
    <Box mt={3}>
      <Typography variant="subtitle2" gutterBottom>
        {t("form.timeUsed", { defaultValue: "Time used" })}
      </Typography>
      <ManualEntryFields
        hours={hours}
        hoursError={hoursErrorText}
        hoursLabel={t("form.hours", { defaultValue: "Hours" })}
        minutes={minutes}
        onChange={({ hours, minutes }) => {
          formik.setFieldValue("hours", hours)
          formik.setFieldValue("minutes", minutes)
        }}
        minutesError={minutesErrorText}
        minutesLabel={t("form.minutes", { defaultValue: "Minutes" })}
      />
    </Box>
  )
}

type Props = {
  formik: FormikProps<HourReportFormState>
}
